import { redirect } from "@tanstack/react-router";
import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { PublicNav } from "@/components/site/PublicNav";
import { Footer } from "@/components/site/Footer";
import { Leaderboard } from "@/components/achievements/Leaderboard";

export const Route = createFileRoute("/leaderboard")({
  // Retired marketplace screen: hidden from visitors, data kept.
  beforeLoad: () => { throw redirect({ to: "/guides" }); },
  head: () => ({
    meta: [
      { title: "Shields leaderboard — top earning partners and customers" },
      {
        name: "description",
        content:
          "See which Shields partners and customers have earned the most verified achievement badges and credit rewards.",
      },
      { property: "og:title", content: "Shields leaderboard — top earners" },
      {
        property: "og:description",
        content: "Verified achievement badges and credit rewards across the Shields community.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: LeaderboardPage,
});

function LeaderboardPage() {
  const [audience, setAudience] = useState<"partner" | "customer">("partner");

  return (
    <div className="min-h-screen">
      <PublicNav />
      <main className="section-pad mx-auto max-w-3xl py-10">
        <Link
          to="/"
          className="flex items-center gap-2 text-sm font-semibold text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" aria-hidden /> Home
        </Link>

        <h1 className="mt-6 font-display text-3xl font-extrabold tracking-tight">
          The Shields <span className="text-premium">leaderboard</span>
        </h1>
        <p className="mt-2 max-w-xl text-muted-foreground">
          Every badge here was earned by finishing real, verified work. Rewards are paid in Shields
          Credits, worth roughly a penny each.
        </p>

        <div className="mt-6 inline-flex rounded-xl border border-border bg-surface p-1">
          {(["partner", "customer"] as const).map((a) => (
            <button
              key={a}
              onClick={() => setAudience(a)}
              className={`min-h-10 rounded-lg px-4 text-sm font-semibold transition ${
                audience === a
                  ? "bg-primary text-primary-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {a === "partner" ? "Partners" : "Customers"}
            </button>
          ))}
        </div>

        <div className="mt-6">
          <Leaderboard audience={audience} />
        </div>
      </main>
      <Footer />
    </div>
  );
}
